document.addEventListener("DOMContentLoaded", function() {
  const modal = document.getElementById("modal");
  const closeModalBtn = document.getElementById("closeBtn");
  const body = document.body;

  document.addEventListener("click", function(e) {
    if (e.target.classList.contains("openModalBtn") || e.target.closest(".openModalBtn")) {
      modal.style.display = "flex";
      body.classList.add("no-scroll");
      console.log('Modal opened');
    }
  });

  closeModalBtn.addEventListener("click", function() {
    modal.style.display = "none";
    body.classList.remove("no-scroll");
    console.log('Modal closed');
  });

  window.addEventListener("click", function(event) {
    if (event.target === modal) {
      modal.style.display = "none";
      body.classList.remove("no-scroll");
    }
  });

  const inchBtn = document.getElementById("inchBtn");
  const cmBtn = document.getElementById("cmBtn");
  const inchContent = document.getElementById("inchContent");
  const cmContent = document.getElementById("cmContent");

  inchBtn.addEventListener("click", function() {
    inchBtn.classList.add("active");
    cmBtn.classList.remove("active");
    inchContent.classList.add("active-content");
    cmContent.classList.remove("active-content");
  });

  cmBtn.addEventListener("click", function() {
    cmBtn.classList.add("active");
    inchBtn.classList.remove("active");
    cmContent.classList.add("active-content");
    inchContent.classList.remove("active-content");
  });
});
